import styled from "styled-components";

export const StyledWaveContainer = styled.div`
    position: relative;
    //z-index: 1;
    
    .wave {
        display: flex;
        //z-index: 2;
        position: relative;
        background-color: transparent;

        &.top {
            position: relative;
            top: 0;
            left: 0;
            width: 100%;
            transform: rotate(180deg);
        }

        &.bottom {
            position: relative;
            bottom: 0;
            left: 0;
            width: 100%;
        }
    }
`